import { Component, OnInit, OnDestroy, ViewChild, Injectable } from '@angular/core';
import { PersonInfoService } from "../../../services/nonanon/person/person-info.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../../shared/notification.component";
import { AuthService } from "../../../services/auth/auth.service";
import { PersonPhotoService } from '../../../services/nonanon/person/person-photo.service';

@Component({
  selector: 'app-person-info',
  templateUrl: './person-info.component.html'
})

export class PersonInfoComponent implements OnInit, OnDestroy {
  @ViewChild('notification') notificationComponent: NotificationComponent;

  onPersonInfoChanged: Subscription;
  onPersonPhotoChange: Subscription;
  onSearchingDriver: Subscription;

  constructor(private personInfoService: PersonInfoService,
    private authService: AuthService,
    private personPhotoService: PersonPhotoService) { }

  errorMessage: string = null;
  hasErrors() {
    return this.errorMessage != null;
  }

  personInfo: any;
  dlRE: string = "";
  loading: boolean = false;

  canCopyToClipboard: boolean = false;

  canViewClientNumber: boolean = false;
  canViewClientName: boolean = false;
  canViewMailingAddress: boolean = false;
  canViewResidentialAddress: boolean = false;
  portal_CanViewClientDOB: boolean = false;
  canViewGender: boolean = false;
  canViewContactNumber: boolean = false;
  canViewDriverLicenceNumber: boolean = false;
  canViewDLClass: boolean = false;
  canViewClientRestriction: boolean = false;
  canViewDLEndorsementsRestrictions: boolean = false;
  canViewDLExpiryDate: boolean = false;
  canViewDLIssueDate: boolean = false;
  canViewDLTerminationDateAndReason: boolean = false;
  canViewClientPhoto: boolean = false;
  canViewDriverStatus: boolean = false;
  canViewDriverLicenceStatus: boolean = false;



  residentalSameAsMailing: boolean;
  residentalSameAsMailingResponseString: string = "";

  // CHECK
  //canViewDriverLicenceStatus: boolean = false;

  ngOnInit() {

    this.loading = true;
    //Security items
    this.canCopyToClipboard = this.authService.getUser().canCopyToClipboard;

    this.canViewClientNumber = this.authService.getUser().canViewClientNumber;
    this.canViewClientName = this.authService.getUser().canViewClientName;
    this.canViewMailingAddress = this.authService.getUser().canViewMailingAddress;
    this.canViewResidentialAddress = this.authService.getUser().canViewResidentialAddress;
    this.portal_CanViewClientDOB = this.authService.getUser().portal_CanViewClientDOB;
    this.canViewGender = this.authService.getUser().canViewGender;
    this.canViewContactNumber = this.authService.getUser().canViewContactNumber;
    this.canViewDriverLicenceNumber = this.authService.getUser().canViewDriverLicenceNumber;
    this.canViewDLClass = this.authService.getUser().canViewDLClass;
    this.canViewClientRestriction = this.authService.getUser().canViewClientRestriction;
    this.canViewDLEndorsementsRestrictions = this.authService.getUser().canViewDLEndorsementsRestrictions;
    this.canViewDLExpiryDate = this.authService.getUser().canViewDLExpiryDate;
    this.canViewDLIssueDate = this.authService.getUser().canViewDLIssueDate;
    this.canViewDLTerminationDateAndReason = this.authService.getUser().canViewDLTerminationDateAndReason;
    this.canViewClientPhoto = this.authService.getUser().canViewClientPhoto;
    this.canViewDriverStatus = this.authService.getUser().canViewDriverStatus;
    this.canViewDriverLicenceStatus = this.authService.getUser().canViewDriverLicenceStatus;
    this.residentalSameAsMailing = this.personInfoService.getPersonInfo().residentalSameAsMailing;

    //if (this.residentalSameAsMailing == true) {
    //  this.residentalSameAsMailingResponseString = "Same as Mailing Address";
    //}

    this.personInfo = this.personInfoService.getPersonInfo();

    // formating dlRestrictionsEndorsements
    this.dlRE = this.personInfo.dlRestrictionsEndorsements;

    if (this.dlRE == null) {
      this.dlRE = "";
    } else {
      var res = this.dlRE.split(',').join(', \n');
      this.dlRE = res;
    }
    // end formatting


    this.loading = false;

    this.onSearchingDriver = this.personInfoService.searchingDriver
      .subscribe(
        (r: boolean) => {
          this.loading = r;
        });

    this.onPersonInfoChanged = this.personInfoService.personInfoChanged
      .subscribe(
        () => {

          this.notificationComponent.animateIfError(this.personInfoService.getResponseInfo());
          if (this.personInfoService.hasErrors()) {
            this.errorMessage = this.personInfoService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.personInfo = this.personInfoService.getPersonInfo();
            this.notificationComponent.clear();
          }
        });
  }

  ngOnDestroy() {
    this.onPersonInfoChanged.unsubscribe();
  }

  copyToClipboard(text) {
    if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/person/person-info.component.ts